import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import SearchGridSection from './section-components/search-grid';
import Footer from './global-components/footer';
import { Helmet } from 'react-helmet';
import PropertyHeader from './global-components/Property-header';
import SearchGridNew from './section-components/search-gridnew';
import BlogContact from '../utils/blogContact';
import { useState } from 'react';
import SearchGridNeww from './section-components/header-search-gridnew';
import MainGridComponent from './MainComponentGrid';

const SearchGrid = () => {
    return <div>
        <Helmet>
            <title>Properties for Sale in Dubai | Apartments, Villas & Off-Plan</title>
            <meta name="description" content="Find your perfect property in Dubai - ready apartments, luxury villas, and off-plan projects. Best prices, verified listings, and expert buying support." />
            <meta name="keywords" content="Properties Dubai" />
            <link rel="canonical" href="https://www.trinestsky.com/properties-dubai" />
        </Helmet>
        <Navbar />
        {/* <PageHeader headertitle="Properties" subheader="Properties" /> */}
        <MainGridComponent/>
        <div style={{ paddingBottom: '35px' }}>
            <BlogContact />
        </div>
        <Footer />
    </div>
}

export default SearchGrid

